<template>
    <flex-element
        :element-type="elementType"
        tag="button"
        class="fc-hamburger-button"
        type="button"
        :exclude-classes="excludedClassGroups"
        @click="toggleDisplay"
    >
        <div class="fc-hamburger-button__icon">
            <span :class="[colorClasses, stateClass]" />
            <span :class="[colorClasses, stateClass]" />
            <span :class="[colorClasses, stateClass]" />
        </div>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { STATE_CLASSES } from '@/data/constants/classes';
import { getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'hamburger-button',
    mixins: [baseOrganism],

    props: {
        active: {
            type: Boolean,
            default: false,
        },

        displayName: {
            type: String,
            default: 'Hamburger Icon',
        },

        // pass in a color to override the one chosen by the user
        // this is used by the "smart color" option
        smartColor: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            excludedClassGroups: ['backgroundColor'],
            isActive: false,
        };
    },

    computed: {
        colorClasses() {
            if (this.smartColor) return this.smartColor;

            return this.htmlClass.filter((className) => {
                const classDefinition = getClassDefinition(className);
                const { tailwindDefinitionProp } = classDefinition;

                return this.excludedClassGroups.includes(tailwindDefinitionProp);
            });
        },

        stateClass() {
            return {
                [STATE_CLASSES.EXPANDED]: this.isActive,
            };
        },
    },

    watch: {
        active(isActive) {
            this.isActive = isActive;
        },
    },

    methods: {
        toggleDisplay() {
            this.isActive = !this.isActive;
            this.$emit('input', this.isActive);
        },
    },
};
</script>

<style lang="scss">
.fc-hamburger-button {
    &__icon {
        @include hamburger-menu-icon();
    }
}
</style>
